import { allocateSelectedFulfillmentPlansFromOrdersGrid } from '../../../store/inventory/inventory.actions';
import { purchaseBulkLabels } from '../../../store/orders/orders.actions';
import { quickSearchFromScanToSearch } from '../../../store/orders/nav/orders.nav.actions';
import { goToOrderDetails } from '../../../store/orders/order-details/orders.details.actions';
import { addFulfillmentPlansOrSalesOrderToBatchRequest, createBatchWithFulfillmentPlans } from '../../../store/batches/batches.actions';

import { display, ship, addNewBatch, addExistingBatch } from './constants';

const getFulfillmentPlanIds = (fulfillmentPlanId, searchResults = []) =>
  fulfillmentPlanId
    ? [fulfillmentPlanId]
    : searchResults.reduce((ids, { fulfillmentPlans }) => ids.concat(fulfillmentPlans.map(({ fulfillmentPlanId: fpId }) => fpId)), []);

const hasOnlyOneOrderAndFulfillmentPlan = (searchResults) => {
  if (searchResults.length === 1) {
    return searchResults[0].fulfillmentPlans?.length === 1;
  }
  return false;
};

export const scanSuccessToActionCreatorMap = {
  [display]: ({ fulfillmentPlan, fulfillmentPlanId, searchResults, orderNumber }, { history, orderStatus }) => {
    if (!fulfillmentPlan && hasOnlyOneOrderAndFulfillmentPlan(searchResults)) {
      const { fulfillmentPlans, salesOrderId } = searchResults[0];
      const fpId = fulfillmentPlans[0].fulfillmentPlanId;
      return goToOrderDetails({ fulfillmentPlanId: fpId, salesOrderId });
    }
    if (orderNumber) {
      return quickSearchFromScanToSearch(orderNumber, orderStatus, history);
    }
    const { salesOrdersFulfilledIds } = fulfillmentPlan;
    const [salesOrderId] = salesOrdersFulfilledIds;
    return goToOrderDetails({ fulfillmentPlanId, salesOrderId });
  },
  [ship]: ({ fulfillmentPlanId, searchResults }) => {
    const fulfillmentPlanIds = getFulfillmentPlanIds(fulfillmentPlanId, searchResults);
    return allocateSelectedFulfillmentPlansFromOrdersGrid(purchaseBulkLabels(false, fulfillmentPlanIds), fulfillmentPlanIds);
  },
  [addNewBatch]: ({ fulfillmentPlanId, searchResults }, { assignToUserId }) => {
    const fulfillmentPlanIds = getFulfillmentPlanIds(fulfillmentPlanId, searchResults);
    return createBatchWithFulfillmentPlans('', assignToUserId, fulfillmentPlanIds);
  },
  [addExistingBatch]: ({ fulfillmentPlanId, searchResults }, { fulfillmentPlanSetId }) => {
    const fulfillmentPlanIds = getFulfillmentPlanIds(fulfillmentPlanId, searchResults);
    return addFulfillmentPlansOrSalesOrderToBatchRequest(fulfillmentPlanSetId, fulfillmentPlanIds);
  },
};
